// extracted by mini-css-extract-plugin
module.exports = {"appsChunk":"Vv9kO9bi","arrowLink":"AvutSO8o","adPlaceholder":"_5oDKXDlN"};